import React, {useEffect, useState} from "react";

import EditPreGameSelections from "../../../assets/images/eoro-2024/edit-pregame-selections.svg";
import MyPreGameTopAndBottomCard from "../MyPreGameSelections/MyPreGameTopAndBottomCard";
import {useSelector} from "react-redux";
import {get} from "../../../Axios/get";
import {GET_PRE_TOURNAMENT_SELECTIONS, STAGING_BASE_URL, USER} from "../../../Axios/EndPoints";
import {useSearchParams} from "react-router-dom";
import SmallLoader from "../../SmallLoader";
import {Col, Row} from "react-bootstrap";
import EuroPreTournament from "../EuroPreTournament";


const MyPreGameSelections = (props) => {
    const {
        isMobile,
        leagueMatchDays,
        leagueId,
        leagueTeams,
        leagueGroups,
    } = props;
    const [params] = useSearchParams();

    const user = useSelector(state => state?.Login);
    const euroAppSettings = useSelector(state => state?.AppSettings?.appSettings?.EURO);
    // console.log("euroAppSettings >>>", euroAppSettings)

    const [loading, setLoading] = useState(false);
    const [mySelections, setMySelections] = useState(null);

    const [edit, setEdit] = useState(false);
    const [isPreSelectionsEditable, setIsPreSelectionsEditable] = useState(false);

    // console.log("isPreSelectionsEditable >>>", isPreSelectionsEditable);
    // console.log("mySelections are >>>", mySelections)

    const fetchMyPreTournamentSelections = () => {
        let token = user?.user?.token;
        let isStaging = parseInt(params.get('staging'));
        setLoading(true);
        get(
            GET_PRE_TOURNAMENT_SELECTIONS,
            true,
            token,
            null,
            isStaging ? STAGING_BASE_URL : ''
        ).then(res => {
            // console.log("reposne for getting my pre tournament selections is >>>", res?.data?.data);
            setMySelections(res?.data?.data);
            setIsPreSelectionsEditable(res?.data?.data?.is_editable);

        }).catch(error => {
            console.error("Error while getting my pre tournament selections is : ", error);
        }).finally(() => {
            setLoading(false);
        });
    };

    useEffect(() => {
        fetchMyPreTournamentSelections()
    }, [user?.isLogin, edit]);


    const renderMobile = () => {
        return (
            <>

                <div className={"px-3"}>
                    {
                        loading ?
                            <>
                                <SmallLoader loading={loading}/>
                            </>
                            :
                            <>
                                {
                                    edit ?
                                        <>
                                            <EuroPreTournament
                                                isMobile={isMobile}
                                                isLogin={user?.isLogin}
                                                user={user}
                                                leagueId={leagueId}
                                                leagueTeams={leagueTeams}
                                                leagueGroups={leagueGroups}
                                                edit={edit}
                                                setEdit={setEdit}
                                                mySelections={mySelections}
                                            />
                                        </>
                                        :
                                        <>
                                            {
                                                isPreSelectionsEditable &&
                                                <>
                                                    <div
                                                        role={"button"}
                                                        className={"d-flex align-items-center justify-content-end gap-2"}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setEdit(true);
                                                            // console.log("Trigger Euro Pre tournament Component")
                                                        }}
                                                    >
                                                        <div className={"text-skins-teal fw-700 cabin font-16"}>Edit
                                                        </div>
                                                        <img
                                                            src={EditPreGameSelections}
                                                            className=""
                                                            alt={"edit"}
                                                            height={20}
                                                            width={20}
                                                        />
                                                    </div>
                                                </>

                                            }


                                            <div
                                                className={"d-flex flex-column align-items-center justify-content-between gap-2"}>
                                                <div className={"w-100"}>
                                                    <div className={"w-100 d-flex flex-column align-items-start gap-2"}>
                                                        <div className={"fw-900 font-14 text-skins-gold"}>
                                                            Golden Team
                                                        </div>
                                                        <div
                                                            className={"w-100 input-select-gold d-flex align-items-center justify-content-center p-2 font-14 fw-900 rounded"}
                                                        >
                                                            {mySelections?.golden_team?.name || "Golden Team Name"}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"w-100"}>
                                                    <div className={"w-100 d-flex flex-column align-items-start gap-2"}>
                                                        <div className={"fw-900 font-14 text-skins-gold"}>
                                                            Tie Break
                                                        </div>
                                                        <div
                                                            className={"w-100 input-select-gold d-flex align-items-center justify-content-center p-2 font-14 fw-900 rounded"}
                                                        >
                                                            {mySelections?.tie_breaker || "Tie Break"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"py-3"}>
                                                <div className={"cabin fw-700 font-14 text-skins-blue"}>
                                                    Your Top & Bottom Team From Each Group
                                                </div>

                                                <Row className={"mt-2 d-flex flex-column gap-3"}>
                                                    {
                                                        mySelections?.group_positions?.map((groupPosition, index) => (
                                                            <MyPreGameTopAndBottomCard
                                                                key={index}
                                                                isMobile={isMobile}
                                                                groupPosition={groupPosition}
                                                            />
                                                        ))
                                                    }
                                                </Row>
                                            </div>
                                        </>
                                }

                            </>
                    }
                </div>
            </>
        );
    }

    const renderDesktop = () => {
        return (
            <>
                <div className={""}>
                    {
                        loading ?
                            <>
                                <SmallLoader loading={loading}/>
                            </>
                            :
                            <>
                                {
                                    edit ?
                                        <>
                                            <EuroPreTournament
                                                isMobile={isMobile}
                                                isLogin={user?.isLogin}
                                                user={user}
                                                leagueId={leagueId}
                                                leagueTeams={leagueTeams}
                                                leagueGroups={leagueGroups}
                                                edit={edit}
                                                setEdit={setEdit}
                                                mySelections={mySelections}
                                            />
                                        </>
                                        :
                                        <>
                                            {
                                                isPreSelectionsEditable &&
                                                <>
                                                    <div
                                                        role={"button"}
                                                        className={"d-flex align-items-center justify-content-end gap-2"}
                                                        onClick={(e) => {
                                                            e.preventDefault();
                                                            setEdit(true);
                                                            // console.log("Trigger Euro Pre tournament Component")
                                                        }}
                                                    >
                                                        <div className={"text-skins-teal fw-700 cabin font-20"}>Edit
                                                        </div>
                                                        <img
                                                            src={EditPreGameSelections}
                                                            className=""
                                                            alt={"edit"}
                                                            height={40}
                                                            width={30}
                                                        />
                                                    </div>
                                                </>
                                            }


                                            <div className={"d-flex align-items-center justify-content-between gap-3"}>
                                                <div className={"w-50"}>
                                                    <div className={"w-100 d-flex flex-column align-items-start gap-2"}>
                                                        <div className={"cabin fw-700 font-20 text-skins-yellow"}>
                                                            Golden Team
                                                        </div>
                                                        <div
                                                            className={"w-100 input-select-yellow d-flex align-items-center justify-content-center p-2 font-20 fw-700 rounded"}
                                                        >
                                                            {mySelections?.golden_team?.name || "Golden Team Name"}
                                                        </div>
                                                    </div>
                                                </div>
                                                <div className={"w-50"}>
                                                    <div className={"w-100 d-flex flex-column align-items-start gap-2"}>
                                                        <div className={"cabin fw-700 font-20 text-skins-yellow"}>
                                                            Tie Break
                                                        </div>
                                                        <div
                                                            className={"w-100 input-select-yellow d-flex align-items-center justify-content-center p-2 font-20 fw-700 rounded"}
                                                        >
                                                            {mySelections?.tie_breaker || "Tie Break"}
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                            <div className={"py-3"}>
                                                <div className={"cabin fw-700 font-20 text-white"}>
                                                    Your Top & Bottom Team From Each Group
                                                </div>

                                                <Row className={"mt-2"}>
                                                    {
                                                        mySelections?.group_positions?.map((groupPosition, index) => (
                                                            <Col
                                                                md={6}
                                                                key={index}
                                                                className={"mb-3"}
                                                            >
                                                                <MyPreGameTopAndBottomCard
                                                                    isMobile={isMobile}
                                                                    groupPosition={groupPosition}
                                                                />
                                                            </Col>
                                                        ))
                                                    }
                                                </Row>
                                            </div>
                                        </>
                                }

                            </>
                    }
                </div>
            </>
        );
    }
    const render = () => {
        return (
            <section>
                {isMobile ? renderMobile() : renderDesktop()}
            </section>
        );
    }

    return render();
}

export default MyPreGameSelections;
